export const STEPS={
    SERVICE:"SERVICE",
    DISABLED:"DISABLED",
    PHONE:"PHONE",
    OTP:"OTP",
    PROFILE_PICKER:"PROFILE_PICKER",
    EDIT_PROFILE:"EDIT_PROFILE",
    GUARDIAN_CONSENT_REQUIRED:"GUARDIAN_CONSENT_REQUIRED",
    GUARDIAN_DETAILS:"GUARDIAN_DETAILS",
    GUARDIAN_WAITING:"GUARDIAN_WAITING",

    
    GUARDIAN_PHONE: "GUARDIAN_PHONE",
    GUARDIAN_OTP: "GUARDIAN_OTP",

    GUARDIAN_CONSENT:"GUARDIAN_CONSENT",
    ELIGIBILITY_QUESTIONS:"ELIGIBILITY_QUESTIONS",
    ELIGIBILITY_WARNING:"ELIGIBILITY_WARNING",
    ELIGIBILITY_DISALLOWED:"ELIGIBILITY_DISALLOWED",
    ACTUAL_WAIVER:"ACTUAL_WAIVER",
    WAIVER_SIGNATURE:"WAIVER_SIGNATURE",
    WAIVER_SUCCESS:"WAIVER_SUCCESS", 
    GUARDIAN_REJECTED: "GUARDIAN_REJECTED",
    MINOR_NOT_ALLOWED: "MINOR_NOT_ALLOWED",
    VIEW_LAST_SIGNED_WAIVER: "VIEW_LAST_SIGNED_WAIVER",

};  

export const getDeviceId = () => {

    let deviceId = localStorage.getItem("deviceIdWvr");

    if (!deviceId) {
        if (crypto?.randomUUID) {
            deviceId = crypto.randomUUID();
        } else {
            deviceId =
                `${Date.now()}-${Math.random()
                    .toString(36)
                    .substring(2, 15)}`;
        }

        localStorage.setItem("deviceIdWvr", deviceId);
    }

    return deviceId;
};

/* Used in functino renderStep in WaiverFlow.jsx */